export default "__VITE_ASSET__BT3GX4QP__"